import {
  PromptInput,
  PromptInputButton,
  PromptInputFooter,
  PromptInputSubmit,
  PromptInputTextarea,
  PromptInputTools,
  Suggestion,
} from "@franklin/ui";
import { ImageIcon, Mic, Paperclip, Sparkles } from "lucide-react";
import type { ChangeEvent, FormEvent } from "react";

type WelcomeScreenProps = {
  onQuickAction: (action: string) => void;
  inputValue: string;
  onInputChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: (event: FormEvent) => void;
  isLoading: boolean;
};

const QUICK_ACTIONS = [
  "Ask a knowledge question",
  "Get support",
  "Status of my open case",
  "Speak with support",
];

export function WelcomeScreen({
  onQuickAction,
  inputValue,
  onInputChange,
  onSubmit,
  isLoading,
}: WelcomeScreenProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-6">
      {/* Welcome Message */}
      <div className="mb-8 flex max-w-[320px] flex-col items-center gap-4">
        <div className="flex h-14 w-14 items-center justify-center">
          <Sparkles
            className="h-8 w-8"
            strokeWidth={1.5}
            style={{ color: "var(--franklin-accent)" }}
          />
        </div>
        <div className="text-center">
          <h3 className="mb-2 font-semibold text-[var(--franklin-foreground)] text-lg">
            Hi! I'm Franklin
          </h3>
          <p className="text-[var(--franklin-muted)] text-sm">
            Your AI-powered assistant. How can I help you today?
          </p>
        </div>
      </div>

      {/* AI Elements Suggestions - vertical pills */}
      <div className="mb-6 flex w-full flex-col items-center gap-2">
        {QUICK_ACTIONS.map((action) => (
          <Suggestion
            key={action}
            onClick={onQuickAction}
            suggestion={action}
          />
        ))}
      </div>

      {/* AI Elements PromptInput - Directly Below Suggestions */}
      <div className="w-full">
        <PromptInput
          onSubmit={(message, event) => {
            event.preventDefault();
            if (message.text?.trim()) {
              onSubmit(event);
            }
          }}
        >
          <PromptInputTextarea
            onChange={onInputChange}
            placeholder="Message Franklin..."
            value={inputValue}
          />
          <PromptInputFooter>
            <PromptInputTools>
              <PromptInputButton title="Attach file">
                <Paperclip className="size-4" />
              </PromptInputButton>
              <PromptInputButton title="Add image">
                <ImageIcon className="size-4" />
              </PromptInputButton>
              <PromptInputButton title="Voice input">
                <Mic className="size-4" />
              </PromptInputButton>
            </PromptInputTools>
            <PromptInputSubmit
              disabled={!inputValue.trim()}
              status={isLoading ? "streaming" : "ready"}
            />
          </PromptInputFooter>
        </PromptInput>
      </div>
    </div>
  );
}
